import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../../utils/url-utils';
import { setFormData } from '../../../utils/network-utils';
import { errorHandl } from '../../../utils/network-utils';
import { environment } from 'src/environments/environment';
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class FleetService {

  public KEY_TOKEN: 'token';

  constructor(private http: HttpClient, private router: Router) { }

  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
   

  getFleetList(payload): Observable<any> {
    const params = new HttpParams({fromObject: payload});
    
    return this.http.get<any>(urls.BASE_URL + urls.FLEET_LIST_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getCredentialedFleetList(payload): Observable<any> {
    const params = new HttpParams({fromObject: payload});
    
    return this.http.get<any>(urls.BASE_URL + urls.CREDENTIALED_FLEET_LIST_URL, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getFleetDataById(fleetId): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.ADD_FLEET_URL + '/' + fleetId)
      .pipe(
        catchError(errorHandl)
      );
  }

  getSingleFleetQR(fleetId): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.SINGLE_FLEET_QR_URL + fleetId)
      .pipe(
        catchError(errorHandl)
      );
  }

  getAllFleetQR(data): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.ALL_FLEET_QR_URL, data)
      .pipe(
        catchError(errorHandl)
      );
  }


  addFleet(fleetData, fleetId): Observable<any> {

    if (fleetId) {
      return this.http.put<any>(urls.BASE_URL + urls.ADD_FLEET_URL + '/' + fleetId, fleetData)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      return this.http.post<any>(urls.BASE_URL + urls.ADD_FLEET_URL, fleetData)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  externalLogin(payload) {
    return this.http.post(`${environment.FLEET_NODE_BASE_URL}third-party/auth/verify-callback`, payload);
  }
  redirectToExternalApp(token: string) {

    const url = `${environment.FLEET_PANEL_BASE_URL}sos?token=${token}`;
    window.open(url, '_blank');
  }

  getBrokerSettingList(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.BROKER_SETTING_URL).pipe(
      catchError(errorHandl)
    );
  }
}
